import React from "react";
import { ChevronDown, ChevronUp } from "react-feather";
import {
  Body,
  ChevronButton,
  Container,
  Header,
  HeaderActions,
  RightCluster,
  TitleButton,
} from "./CollapsibleSection.styles";
import type { CollapsibleSectionProps } from "./CollapsibleSection.types";

const CHEVRON_SIZE = 24;

/**
 * Collapsible card-shaped section used by the connection-detail tables
 * (Connected dataset, Connection logs).
 *
 * Layout: title on the left (clickable to toggle), right cluster on the
 * right with optional `headerActions` followed by the chevron toggle
 * button. Stateless — `expanded` is owned by the parent so multiple
 * sections can coordinate (e.g. open/close all).
 */
export const CollapsibleSection: React.FC<CollapsibleSectionProps> = ({
  title,
  expanded,
  onToggle,
  headerActions,
  children,
  className,
}) => (
  <Container className={className}>
    <Header>
      <TitleButton
        type="button"
        aria-expanded={expanded}
        onClick={onToggle}
      >
        {title}
      </TitleButton>
      <RightCluster>
        {headerActions ? <HeaderActions>{headerActions}</HeaderActions> : null}
        <ChevronButton
          type="button"
          aria-expanded={expanded}
          aria-label={expanded ? "Collapse section" : "Expand section"}
          onClick={onToggle}
        >
          {expanded ? (
            <ChevronUp size={CHEVRON_SIZE} aria-hidden />
          ) : (
            <ChevronDown size={CHEVRON_SIZE} aria-hidden />
          )}
        </ChevronButton>
      </RightCluster>
    </Header>
    {expanded ? <Body>{children}</Body> : null}
  </Container>
);

export default CollapsibleSection;
